var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "tabDetail position-relative" },
    [
      _c(
        "v-tabs",
        {
          attrs: {
            "next-icon": "mdi-arrow-right-bold-box-outline",
            "prev-icon": "mdi-arrow-left-bold-box-outline",
            "show-arrows": "",
          },
          on: { change: _vm.changeTab },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tabs-slider"),
          _vm._v(" "),
          _vm._l(_vm.filteredItems, function (item) {
            return _c("v-tab", { key: item.label }, [
              _c("span", { staticClass: "tabDetail__tab" }, [
                _vm._v("\n      " + _vm._s(item.label) + "\n    "),
              ]),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        _vm._l(_vm.filteredItems, function (tabItem) {
          return _c(
            "v-tab-item",
            { key: tabItem.label },
            [
              _c("v-card", { attrs: { flat: "" } }, [
                _c("div", {
                  staticClass: "tabDetail__grid",
                  domProps: { innerHTML: _vm._s(tabItem.descr) },
                }),
                _vm._v(" "),
                Array.isArray(tabItem.additional) &&
                tabItem.additional.length > 0
                  ? _c(
                      "div",
                      { staticClass: "tabDetail__files-grid" },
                      _vm._l(tabItem.additional, function (file, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "tabDetail__item position-relative",
                          },
                          [
                            _c("a", {
                              staticClass: "tabDetail__link position-absolute",
                              attrs: { href: file.link, target: "_blank" },
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "tabDetail__img-icon",
                              attrs: { src: "/upload/pad_img.svg", alt: "" },
                            }),
                            _vm._v(" "),
                            _c("h3", { staticClass: "tabDetail__title" }, [
                              _vm._v(_vm._s(file.title)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "tabDetail__download" }, [
                              _c("span", [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "24",
                                      height: "24",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      xmlns: "http://w3.org",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M4 15.2044L4 18.8925C4 19.4514 4.21071 19.9875 4.58579 20.3827C4.96086 20.778 5.46957 21 6 21H18C18.5304 21 19.0391 20.778 19.4142 20.3827C19.7893 19.9875 20 19.4514 20 18.8925V15.2044M12.0011 3V14.9425M12.0011 14.9425L16.5725 10.3793M12.0011 14.9425L7.42969 10.3793",
                                        stroke: "#F94237",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                              _vm._v(
                                "\n                            Скачать\n                        "
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }